import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const STOREFRONT_IMG = "/images/storefront.jpg";

export default function About() {
  const { t } = useLanguage();
  const stats = [
    { label: t("about.stat1Label"), value: t("about.stat1Value") },
    { label: t("about.stat2Label"), value: t("about.stat2Value") },
    { label: t("about.stat3Label"), value: t("about.stat3Value") },
  ];

  return (
    <section id="about" data-testid="about-section" className="relative bg-[#F9F6F0] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Storefront photo */}
        <div className="lg:col-span-6 relative h-[460px] md:h-[620px] order-2 lg:order-1">
          <div className="relative w-full h-full rounded-2xl overflow-hidden border border-[#E2D9CD] shadow-md">
            <img
              src={STOREFRONT_IMG}
              alt="La Hacienda Michoacana Supermarket storefront"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -top-4 -right-2 hidden md:block">
            <div className="bg-[#C05A3A] text-[#F9F6F0] rounded-full px-5 py-3 font-serif-display italic text-lg shadow-lg">
              ¡Bienvenidos!
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="lg:col-span-6 order-1 lg:order-2">
          <span className="text-[12px] uppercase tracking-[0.22em] text-[#C05A3A] font-medium">
            {t("about.eyebrow")}
          </span>
          <h2
            data-testid="about-title"
            className="font-serif-display text-[#232321] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-4"
          >
            {t("about.title")}
          </h2>
          <div className="mt-6 space-y-5 text-[#5C5C59] text-base leading-relaxed max-w-xl">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
            {stats.map((s, i) => (
              <div key={s.label} data-testid={`about-stat-${i}`} className="border-l-2 border-[#C05A3A] pl-4">
                <div className="font-serif-display text-3xl text-[#232321]">{s.value}</div>
                <div className="text-[11px] uppercase tracking-[0.15em] text-[#5C5C59] mt-2 leading-snug">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
